/* JDP: IN STOCK markers. Listing cards: green top-left tag. Product page: big green ribbon. */
(function(){
var KEY='jdp_instock_v1';
function list(){
 try{var c=JSON.parse(sessionStorage.getItem(KEY)||'null');if(c&&Date.now()-c.t<300000)return Promise.resolve(c.h)}catch(e){}
 var h=[];
 function pg(n){return fetch('/collections/in-stock-now/products.json?limit=250&page='+n).then(function(r){return r.ok?r.json():{products:[]}}).then(function(j){var p=j.products||[];p.forEach(function(x){h.push(x.handle)});return p.length===250&&n<10?pg(n+1):h})}
 return pg(1).then(function(h){try{sessionStorage.setItem(KEY,JSON.stringify({t:Date.now(),h:h}))}catch(e){}return h}).catch(function(){return []});
}
function handleOf(a){var m=((a&&a.getAttribute('href'))||'').match(/\/products\/([^\/?#]+)/);return m?decodeURIComponent(m[1]):null}
function rib(host,cls){
 if(!host)return;
 for(var i=0;i<host.children.length;i++){if(host.children[i].classList.contains('jdp-ribbon-instock'))return}
 host.classList.add('jdp-rb-host');
 var s=document.createElement('span');s.className='jdp-ribbon-instock'+(cls?' '+cls:'');s.textContent='In Stock';host.appendChild(s);
}
function tag(host,cls){
 if(!host||host.querySelector('.jdp-tag-instock,.badge-instock'))return;
 host.classList.add('jdp-tag-host');
 var s=document.createElement('span');s.className='jdp-tag-instock'+(cls?' '+cls:'');s.textContent='In Stock';host.appendChild(s);
}
var set=null;
function scan(){
 if(window.JDP_PRODUCT_INSTOCK){rib(document.querySelector('.product-media-main-wrapper')||document.querySelector('.product-media-gallery'),'lg')}
 if(!set)return;
 document.querySelectorAll('.card-product').forEach(function(c){if(c.querySelector('.badge-instock'))return;var h=handleOf(c.querySelector('a[href*="/products/"]'));if(h&&set[h])tag(c.querySelector('.card-media'))});
 document.querySelectorAll('a.jn-c,a.sh-c').forEach(function(a){var h=handleOf(a);if(h&&set[h])tag(a.querySelector('.jn-im,.sh-im'),'sm')});
}
var t;function later(){clearTimeout(t);t=setTimeout(scan,150)}
function start(){
 scan();
 list().then(function(h){set={};h.forEach(function(x){set[x]=1});scan()});
 try{new MutationObserver(later).observe(document.body,{childList:true,subtree:true})}catch(e){}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
